/** Shared lists for Kerala medical colleges and department options. */

export const KERALA_COLLEGES: string[] = [
  // Government
  'Government Medical College, Thiruvananthapuram',
  'Government Medical College, Kozhikode',
  'Government Medical College, Kottayam',
  'Government Medical College, Thrissur',
  'Government Medical College, Alappuzha',
  'Government Medical College, Ernakulam',
  'Government Medical College, Kannur',
  'Government Medical College, Manjeri',
  'Government Medical College, Palakkad',
  'Government Medical College, Kollam',
  'Government Medical College, Kasaragod',
  'Government Medical College, Idukki',
  'Government Medical College, Pathanamthitta',
  'Sree Uthradom Thirunal Academy of Medical Sciences, Thiruvananthapuram',
  // Private / Aided
  'Amrita Institute of Medical Sciences, Kochi',
  'Jubilee Mission Medical College, Thrissur',
  'Pushpagiri Medical College, Thiruvalla',
  'Believers Church Medical College, Thiruvalla',
  'Sree Gokulam Medical College, Thiruvananthapuram',
  'Azeezia Medical College, Kollam',
  'Dr. Somervell Memorial CSI Medical College, Karakonam',
  'MES Medical College, Perinthalmanna',
  'Malabar Medical College, Kozhikode',
  'MOSC Medical College, Kolenchery',
  'PK Das Medical College, Ottapalam',
  'Noorul Islam Medical College, Thiruvananthapuram',
  'Pariyaram Medical College, Kannur',
  'KMCT Medical College, Kozhikode',
  'Al Azhar Medical College, Thodupuzha',
  'Sree Narayana Institute of Medical Sciences, Ernakulam',
  'Kannur Medical College, Anjarakandy',
  'Mount Zion Medical College, Pathanamthitta',
  'DM WIMS Medical College, Wayanad',
  'Aster MIMS, Kozhikode',
  'Travancore Medical College, Kollam',
];

export const DEPARTMENT_OPTIONS: string[] = [
  'DEPARTMENT OF ORTHOPAEDICS',
  'DEPARTMENT OF GENERAL SURGERY',
  'DEPARTMENT OF NEUROSURGERY',
  'DEPARTMENT OF CARDIOTHORACIC SURGERY',
  'DEPARTMENT OF OBSTETRICS & GYNAECOLOGY',
  'DEPARTMENT OF ENT',
  'DEPARTMENT OF UROLOGY',
  'DEPARTMENT OF MEDICINE',
  'DEPARTMENT OF CARDIOLOGY',
  'DEPARTMENT OF PAEDIATRICS',
];
